import React from "react";

const Java_Booleans = () => {
  return (
    <div>
      <h1>Java Booleans</h1>
      <p>This page provides explanations, examples, and common use-cases for Java Booleans in Java.</p>
    </div>
  );
};

export default Java_Booleans;
